import { ActionsCard } from 'organisms';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { inviteClassroomToJobFinder } from 'actions';

const InviteCard = ({
  classId,
  inviteClassroom,
  inviteState,
  // B2CY-1665 (https://app.clickup.com/t/9010076192/B2CY-1665)
  // Step 1 (Jul 15): "Invite class to Job Check" action hidden — inviting students is no longer possible.
  // Step 2 (Jul 31): full deactivation — no one can do a Job Check anymore.
  ...args
}) => {
  const { t } = useTranslation();
  const actions = [
    {
      text: t('action_card_link_2'),
      onClick: id => {
        inviteClassroom(id);
      },
      state: inviteState,
    },
  ];

  return (
    <ActionsCard
      actions={actions}
      title={t('action_card_title')}
      subtitle={t('action_card_subtitle')}
      classId={classId}
      {...args}
    />
  );
};

const mapStateToProps = state => ({
  classId: state.classroomState.classroomData.id,
  inviteState: state.classroomState.invite,
});

const mapDispatchToProps = dispatch => ({
  inviteClassroom: id => dispatch(inviteClassroomToJobFinder(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InviteCard);
